const SCORE_FIELDS = 'id, quality_score, archetype, updated_at, updated_by';

const PRIORITY_FIELDS = 'user_id, quality_score, interview_boost, validation_boost, final_priority';

export {
  PRIORITY_FIELDS,
  SCORE_FIELDS,
};
